/* eslint-disable react-hooks/exhaustive-deps */
import { Button, CircularProgress, Grid, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import validate from "validate.js";
import {
  resetStateAuth,
  userLogin,
  verifyEmail,
} from "../../app/slices/authSlice";
import { showSnackbar } from "../../app/slices/commonSlice";
import logo from "../../assets/images/logo.png";
import "./Auth.css";

const Login = () => {
  const {
    data: dataLogin,
    status: statusLogin,
    error: errorLogin,
  } = useSelector(({ auth }) => auth.login);
  const {
    data: dataVerifyEmail,
    status: statusVerifyEmail,
    error: errorVerifyEmail,
  } = useSelector(({ auth }) => auth.verifyEmail);

  const [errors, setErrors] = useState([]);
  const [action, setAction] = useState("email");
  const [formValues, setFormValues] = useState({});
  const [message, setMessage] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetStateAuth());
    setMessage("Provide your email address");
    return () => {
      dispatch(resetStateAuth());
    };
  }, []);

  useEffect(() => {
    if (dataLogin) {
      dispatch(
        showSnackbar({
          open: true,
          type: "success",
          message: "Logged in successfully.",
          timeout: 1000,
        }),
      );
      window.location.replace("/");
    }
  }, [dataLogin]);

  useEffect(() => {
    if (dataVerifyEmail) {
      setMessage(
        "We have sent you a password to sign in in your email or phone number. Please provide it below to proceed",
      );
      setAction("password");
    }
  }, [dataVerifyEmail]);

  useEffect(() => {
    if (errorVerifyEmail || errorLogin) {
      dispatch(
        showSnackbar({
          open: true,
          message: errorVerifyEmail?.message || errorLogin?.message,
          type: "error",
        }),
      );
    }
  }, [errorVerifyEmail, errorLogin]);

  const handleChange = (e) => {
    const inputName = e.target.name;
    const inputValue = e.target.value;

    setFormValues({
      ...formValues,
      [inputName]: inputValue,
    });
  };

  const handleSubmit = () => {
    if (action === "email") {
      handleValidateEmail();
    } else if (action === "password") {
      handleLogin();
    }
  };

  const handleValidateEmail = () => {
    let _errors = validate(formValues, {
      email: {
        presence: { allowEmpty: false },
        email: true,
      },
    });

    if (_errors) {
      setErrors(_errors);
      return;
    } else {
      setErrors([]);
    }

    dispatch(resetStateAuth(["verifyEmail"]));

    dispatch(
      verifyEmail({
        EMAIL: formValues?.email,
      }),
    );
  };

  const handleLogin = () => {
    let _errors = validate(formValues, {
      password: {
        presence: { allowEmpty: false },
      },
    });

    if (_errors) {
      setErrors(_errors);
      return;
    } else {
      setErrors([]);
      dispatch(
        userLogin({
          EMAIL: formValues?.email,
          PASSWORD: formValues?.password,
        }),
      );
    }
  };

  const BuildForm = () => (
    <div className="app-form">
      <img
        src={logo}
        alt="Bank of Tanzania"
        style={{
          display: "block",
          margin: "0 auto 20px",
          height: "120px",
        }}
      />

      <h3 style={{ textAlign: "center", marginBottom: 20 }}>
        Bank of Tanzania Library
      </h3>

      <h2 style={{ marginBottom: 20 }}>Sign In</h2>

      <div style={{ marginBottom: 16 }}>{message}</div>

      <Grid container spacing={2}>
        {action === "email" && (
          <Grid item size={12} >
            <TextField
              required
              fullWidth
              margin="dense"
              variant="outlined"
              autoComplete="new-password"
              name="email"
              label="Email"
              value={formValues.email || ""}
              onChange={handleChange}
              error={Boolean(errors.email)}
              helperText={errors.email?.[0] || ""}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleSubmit();
              }}
            />
          </Grid>
        )}

        {action === "password" && (
          <Grid item size={12}>
            <TextField
              required
              fullWidth
              margin="dense"
              type="password"
              variant="outlined"
              autoComplete="new-password"
              name="password"
              label="Password"
              value={formValues.password || ""}
              onChange={handleChange}
              error={Boolean(errors.password)}
              helperText={errors.password?.[0] || ""}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleSubmit();
              }}
            />
          </Grid>
        )}

        <Grid item size={12}>
          <Button
            fullWidth
            variant="contained"
            onClick={handleSubmit}
            disabled={
              statusVerifyEmail === "loading" ||
              statusLogin === "loading" ||
              dataLogin
            }
          >
            {(statusVerifyEmail === "loading" || statusLogin === "loading") && (
              <CircularProgress size={20} sx={{ mr: 1 }} />
            )}
            {action === "email" ? "Sign In" : "Continue"}
          </Button>
        </Grid>

        <Grid size={12}>
          <Button
            fullWidth
            variant="text"
            onClick={() => window.location.replace("/")}
          >
            Return to Main Page
          </Button>
        </Grid>
      </Grid>
    </div>
  );

  return (
    <div className="flex-row auth-container flex-wrap">
      <div className="flex-row align-items-center justify-content-center">
        {BuildForm()}
      </div>
    </div>
  );
};

export default Login;
